export const USER_DETAILS = "USER_DETAILS";
